import { render, staticRenderFns } from "./InvoiceCell.vue?vue&type=template&id=60c1c6da&lang=html&"
import script from "./InvoiceCell.vue?vue&type=script&lang=js&"
export * from "./InvoiceCell.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCell.vue?vue&type=style&index=0&id=60c1c6da&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports